import type { SVGProps } from "react";
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#F0BB44"
      d="m10 12 4-4-4-4-.933.933 2.4 2.4H2v1.334h9.467l-2.4 2.4z"
    />
  </svg>
);
export default SvgArrowRight;
